import { StyleObject } from "@/utils/helpers"
import { typographyClasses } from "@mui/material"

export const statsWrapper: StyleObject = {
  p: { xs: 0.5, sm: 1 },
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  [`& .${typographyClasses.root}`]: {
    fontSize: { xs: 12, sm: 14 },
  },
}

export const statTitleWrapper = {
  display: "flex",
  alignItems: "center",
  gap: { xs: 0.25, md: 1 },
  minWidth: { xs: 180, sm: 200 },
  [`.${typographyClasses.root}`]: {
    fontSize: { xs: 12, sm: 14 },
  },
}

export const statContent = {
  fontSize: { xs: 12, sm: 14 },
  [`& .${typographyClasses.root}`]: {
    fontSize: { xs: 12, sm: 14 },
  },
}
